// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"3362":"d38ce3ba5c768566","8859":"5360b3140728e219"}[chunkId] + ".css";
};